import { Outlet } from "react-router-dom";
import { ChatProvider } from "../context/ChatContext";
import { NotificationProvider } from "../context/NotificationContext";
import { VerificationProvider } from "../context/VerificationContext";
import ChatModal from "./chat/ChatModal";
import Header from "./Header";
import VerificationPopup from "./VerificationPopup";

const MainLayout = () => {
    return (
        <NotificationProvider>
            <ChatProvider>
                <VerificationProvider>
                    <Header />
                    <div className="content-wrapper">
                        <Outlet />
                        {/* Vykreslení tras definovaných v `layoutRoutes` */}
                    </div>
                    <ChatModal />
                    <VerificationPopup />
                </VerificationProvider>
            </ChatProvider>
        </NotificationProvider>
    );
};

export default MainLayout;
